import {Component, Input, OnInit} from '@angular/core';
import {EmptyState} from "../../shared/models/domain/empty-state";
import {StaticValuesUtils} from "../../utils/static-values/static-values.utils";
import {ScreenUtils} from "../../utils/screen.utils";
import {GenericEvent} from "../../models/genericEvent";
import {UpaService} from "../../services/upa/upa.service";
import {AppSettingsService} from "../../services/app-settings/app-settings.service";
import { SearchboxV2Service } from '@shopping-angular-components/searchbox-v2';

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent implements OnInit {

  @Input() emptyState: EmptyState;
  image: string;
  isMobile: boolean = ScreenUtils.isMobile();

  constructor(private searchboxV2Service: SearchboxV2Service,
              private upaService: UpaService,
              private appSettingsService: AppSettingsService) { }

  executeAction() {
    let action = 'emptyState-' + this.emptyState.type;
    this.upaService.track(GenericEvent.newUserAction(action, 'click', {
      channel: this.appSettingsService.getChannel(),
      site: this.appSettingsService.getSite(),
      lang: this.appSettingsService.getLanguage(),
      userId: this.appSettingsService.getUserId()
    }));

    if (this.emptyState.redirectTo) {
      window.location.href = this.emptyState.redirectTo;
    }
    else {
      this.searchboxV2Service.highlightSearchbox.emit();
    }

  }

  ngOnInit() {
    if (this.emptyState.image) {
        let size = (this.isMobile)? "/250x200" : "";
        this.image = StaticValuesUtils.getMediaPicturesEndpoint() + this.emptyState.image + size;
    }

  }

}
